import API from '../apiClient';
import { handleApiError } from '../Utils/errorHandler';

export const userLogin = (payload) => {
    return new Promise((resolve,reject) => {
        API.post(`/login/`, payload)
        .then(response => {
            resolve(response);
        }) .catch(error =>{
            const errorResult = handleApiError(error, 'Failed to Login');
            reject(errorResult);
        });
    });
}

export const getAuthOptions = () => API.get('/login/auth-options');

export const startOAuthLogin = (provider) => {
    const origin = encodeURIComponent(window.location.origin);
    return API.get(`/login/oauth/${provider}?origin=${origin}`)
        .then((response) => response)
        .catch((error) => {
            throw handleApiError(error, 'Failed to start sign-in');
        });
};

export const completeOAuthLogin = (ticket) => {
    return API.post(`/login/oauth/complete`, { ticket })
        .then((response) => response)
        .catch((error) => {
            throw handleApiError(error, 'Failed to complete sign-in');
        });
};

export const discoverCompanySSO = (email) => {
    return API.get(`/login/sso/discover?email=${encodeURIComponent(email)}`)
        .then((response) => response)
        .catch((error) => {
            throw handleApiError(error, 'Company SSO is not configured for this email');
        });
};

export const startCompanySSO = (email) => {
    const origin = encodeURIComponent(window.location.origin);
    return API.get(`/login/sso/entra?email=${encodeURIComponent(email)}&origin=${origin}`)
        .then((response) => response)
        .catch((error) => {
            throw handleApiError(error, 'Failed to start company SSO');
        });
};